import { expireSession, sessionEpoch, sessionSignal, sessionToken } from './session'

export const BASE_URL = (process.env.VUE_APP_DIAGNOSE_API || (process.env.NODE_ENV === 'production' ? '/stn' : '')).replace(/\/+$/, '')

export async function apiFetch(path, options = {}) {
  const epoch = sessionEpoch()
  const headers = new Headers(options.headers || {})
  if (sessionToken()) headers.set('Authorization', `Bearer ${sessionToken()}`)
  const controller = new AbortController()
  const signals = [sessionSignal(), options.signal].filter(Boolean)
  const abort = () => controller.abort()
  signals.forEach(signal => { if (signal.aborted) abort(); else signal.addEventListener('abort', abort, { once: true }) })
  const timeout = setTimeout(abort, options.timeoutMs || 60000)
  try {
    const response = await fetch(`${BASE_URL}${path}`, { ...options, headers, signal: controller.signal, cache: 'no-store', credentials: 'omit' })
    if (epoch !== sessionEpoch()) throw new Error('账号已切换，本次请求已取消。')
    if (!response.ok) {
      let detail = `请求失败（${response.status}）`
      try { const body = await response.json(); if (typeof body.detail === 'string') detail = body.detail } catch (e) { void e }
      if (epoch !== sessionEpoch()) throw new Error('账号已切换，本次请求已取消。')
      if (response.status === 401 || response.headers.get('X-STN-Account-Disabled') === '1') expireSession(detail)
      throw new Error(detail)
    }
    return response
  } catch (error) {
    if (error.name === 'AbortError') throw new Error('请求已取消或超时，请重试。')
    throw error
  } finally {
    clearTimeout(timeout)
    signals.forEach(signal => signal.removeEventListener('abort', abort))
  }
}

export async function apiJSON(path, options = {}) {
  const epoch = sessionEpoch()
  const data = await (await apiFetch(path, options)).json()
  if (epoch !== sessionEpoch()) throw new Error('账号已切换，本次请求已取消。')
  return data
}

export const jsonBody = (method, data) => ({ method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
